import { useContext } from 'react';
import { PacientProfileChartsDataContext } from '../contexts/PacientProfileChartsDataContext';

export const usePacientProfileChartsDataContext = () => {
    return useContext(PacientProfileChartsDataContext);
};
